import {
  FC,
  useState,
  createContext,
  Dispatch,
  ReactNode,
  useContext,
} from 'react'
import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'

export const FeedBackContext = createContext<{
  open: boolean
  message: string
  setOpen: Dispatch<boolean>
  setMessage: Dispatch<string>
}>({ open: false, message: '', setOpen: () => {}, setMessage: () => {} })

export const useFeedBackState = () => useContext(FeedBackContext)

const FeedBackState: FC<{ children: ReactNode }> = ({ children }) => {
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const isSuccess = message.includes('成功しました')
  const handleClose = () => {
    setOpen(false)
  }
  return (
    <FeedBackContext.Provider value={{ open, message, setOpen, setMessage }}>
      {children}
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          tw="w-full"
          severity={isSuccess ? 'success' : 'error'}
          variant="filled"
          onClose={handleClose}
        >
          {message}
        </Alert>
      </Snackbar>
    </FeedBackContext.Provider>
  )
}

export default FeedBackState
